import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import CourseDetailsContent from './CourseDetailsContent'
export default class CourseDetails extends React.Component {
    
    render() {
        let id = this.props.match.params.id;
        let page = this.props.match.params.page;


        const urlParams = new URLSearchParams(window.location.search);
        return (
            <div className="wrapper">

                <div className="preloader hide flex-column justify-content-center align-items-center">
                    <img className="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <CourseDetailsContent id={id} page={page} urlParams={urlParams} />
                <Footer /> 

            </div>


        )
    }
}
